import { render, staticRenderFns } from "./GestionInicialInformes.vue?vue&type=template&id=6a6f5bcb&"
import script from "./GestionInicialInformes.vue?vue&type=script&lang=js&"
export * from "./GestionInicialInformes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports